import { getUniqueCIdentifierCopyFileName, INVALID_C_IDENTIFIER_MESSAGE, isValidCIdentifier } from '@lved/shared-core';
import URI from '@theia/core/lib/common/uri';
import { inject, injectable } from '@theia/core/shared/inversify';
import { WorkspaceDuplicateHandler } from '@theia/workspace/lib/browser/workspace-duplicate-handler';
import { FileStat } from '@theia/filesystem/lib/common/files';
import { MessageService } from '@theia/core/lib/common/message-service';

@injectable()
export class LvglWorkspaceDuplicateHandler extends WorkspaceDuplicateHandler {
    @inject(MessageService)
    protected readonly messageService!: MessageService;

    override async execute(uris: URI[]): Promise<void> {
        const reservedNames: Set<string> = new Set<string>();

        for (const uri of uris) {
            try {
                const parent: FileStat = await this.fileService.resolve(uri.parent);

                if (!isValidCIdentifier(uri.path.name)) throw new Error(INVALID_C_IDENTIFIER_MESSAGE);

                const existingNames: Set<string> = new Set<string>(
                    (parent.children ?? []).map((child): string => child.name)
                );
                reservedNames.forEach((name) => existingNames.add(name));

                const targetName: string = getUniqueCIdentifierCopyFileName(uri.path.base, existingNames);
                reservedNames.add(targetName);

                const target: URI = uri.parent.resolve(targetName);
                await this.fileService.copy(uri, target);
            } catch (error: unknown) {
                const message = error instanceof Error ? error.message : String(error);
                this.messageService.error(message);
            }
        }
    }
}
